export type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

export enum TeacherStatusEnum {
    Academic = 'Academic',
    Administrator = 'Administrator',
};
